var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSource3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 2.667,
    fill: "#000",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 15.5,
    height: 15.5,
    rx: 2.417,
    stroke: "#000",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.342 8.234v-.963h.375c.371 0 .66-.103.864-.308.205-.198.308-.454.308-.77a1.1 1.1 0 00-.318-.787c-.205-.198-.469-.3-.792-.307-.232 0-.444.074-.635.224-.202.15-.337.38-.406.692H5.649a2.217 2.217 0 01.682-1.421 1.984 1.984 0 011.407-.584c.69.007 1.24.228 1.645.662.39.423.587.923.594 1.5 0 .291-.052.573-.156.843-.122.271-.339.513-.651.724.32.209.55.459.693.75.135.292.203.598.203.917-.007.712-.228 1.273-.662 1.682-.427.42-.975.634-1.646.641-.517 0-.975-.167-1.375-.5-.399-.333-.658-.816-.776-1.448h1.089c.097.254.234.458.411.615.181.163.42.244.72.244.319 0 .588-.109.806-.328.223-.204.337-.496.344-.875-.007-.385-.121-.684-.344-.896-.218-.204-.496-.307-.833-.307h-.458z",
    fill: "#000",
    fillOpacity: 0.6
  })));
}
export default SvgSource3;